import { GUIDE_TOUR_BLOCKED_TARGET_INTERACTION_MESSAGE_LINES } from '../types'
import type { GuideTourStep } from '../types'
import * as S from './styles'

type GuideTourStepCardHeaderProps = Readonly<{
  currentStep: GuideTourStep
  currentStepNumber: number
  stepCount: number
  isSummaryOnly: boolean
  routeTourQueue: { position: number; total: number } | null
  skippedStepNoticeMessage: string | null
  isBlockedTargetInteractionWarningVisible: boolean
}>

export function GuideTourStepCardHeader({
  currentStep,
  currentStepNumber,
  stepCount,
  isSummaryOnly,
  routeTourQueue,
  skippedStepNoticeMessage,
  isBlockedTargetInteractionWarningVisible,
}: GuideTourStepCardHeaderProps) {
  const stepLabel = isSummaryOnly
    ? 'Tour de novidades'
    : `Passo ${currentStepNumber} de ${stepCount}`

  return (
    <S.Header>
      {routeTourQueue ? (
        <S.HeaderTopRow>
          <S.RouteTourLabel data-testid="guide-tour-route-queue-label">
            Novidade {routeTourQueue.position} de {routeTourQueue.total}
          </S.RouteTourLabel>
          {currentStep.badge ? <S.Badge>{currentStep.badge}</S.Badge> : null}
        </S.HeaderTopRow>
      ) : null}
      {routeTourQueue ? (
        <S.StepLabel>{stepLabel}</S.StepLabel>
      ) : (
        <S.StepMetaRow>
          <S.StepLabel>{stepLabel}</S.StepLabel>
          {currentStep.badge ? <S.Badge>{currentStep.badge}</S.Badge> : null}
        </S.StepMetaRow>
      )}
      {skippedStepNoticeMessage ? (
        <S.SkippedStepInfoNotice
          data-testid="guide-tour-skipped-step-notice"
          id="guide-tour-skipped-step-notice"
          role="status"
        >
          <span>
            {isSummaryOnly ? (
              <span id="guide-tour-skipped-summary-title">
                {skippedStepNoticeMessage}
              </span>
            ) : (
              skippedStepNoticeMessage
            )}
          </span>
        </S.SkippedStepInfoNotice>
      ) : null}
      {isBlockedTargetInteractionWarningVisible ? (
        <S.BlockedInteractionDangerNotice
          data-testid="guide-tour-blocked-interaction-warning"
          role="alert"
        >
          {GUIDE_TOUR_BLOCKED_TARGET_INTERACTION_MESSAGE_LINES.map(line => (
            <span key={line}>{line}</span>
          ))}
        </S.BlockedInteractionDangerNotice>
      ) : null}
    </S.Header>
  )
}
